import {
  setup,
  locale,
  getMessage as i18nGetMessage,
  currencyFormatter as i18nCurrencyFormatter,
  getFormattedMessage
} from '@tcc/i18n';
import englishFile from '../../i18n/en.json';
import { logError } from 'api/errors';
import { NO_DECIMAL_CURRENCY_CODES } from 'constants/countryCodes';

/** Wrappers to manage errors - show in dev, hide in prod
 * @param {string} key
 * @param {object} [params]
 * @returns {string}
 */
export const getMessage = (key, params) => {
  let result = '';
  if (!params) {
    return i18nGetMessage(key) || ''; // undefined when no such key
  }

  try {
    // Can die if key doesn't exist at all
    // Can die if a param in msg isn't passed
    result = getFormattedMessage(key, params) || '';
  } catch (error) {
    logError({ error, message: `failed on ${key} ${JSON.stringify(params)}` });
    result = '';
  }

  return result;
};

export const getCropBasedMessage = ({
  key,
  cropId,
  params
}) => {
  if(params) {
    return getMessage(`${key}.${cropId}`, params);
  }
  return getMessage(`${key}.${cropId}`);
};

export const getLocaleLang = () => locale;

export const setupI18n = async () => {
  return setup({
    project: {
      s3Name: 'variable-rate',
      smartlingName: 'script-creator-plugin'
    },
    englishFile,
  });
};

/**
 * Wrapper for i18n's currencyFormatter
 * @param {Number|String} value
 * @param {String} currency
 * @param {Object} [opts]
 * @param {Boolean} [opts.round]
 * @param {String} [opts.locale]
 * @param {String} [opts.country]
 * @returns {String}
 */
export const currencyFormatter = (value, currency, opts) => {
  try {

    if (typeof opts === 'undefined') {
      opts = { round: false, locale: '', country: '' };
    }
    const numValue = Number(value);
    const isNoDecimalCurrency = NO_DECIMAL_CURRENCY_CODES.find(curr => curr === currency);
    if (typeof isNoDecimalCurrency !== 'undefined') {
      opts.round = true;
    }
    if (!isNaN(numValue)) {
      opts.locale = getLocaleLang();
      return i18nCurrencyFormatter(Number(value), currency, opts);
    }
    return value;
  }
  catch (ignore) {
    return value;
  }
};
